import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles({
  bulletIndicator: {
    fontSize: 8,
    margin: "0 2px"
  },
  workoutDetailsDataItem: {
    margin: "0 2px"
  },
  courseTypeSymbol: {
    scale: 0.8,
    position: "relative",
    top: -2
  }
});
